import authenticate from "@/urls/authenticate";
const HOST_ACCOUNT = process.env.VUE_APP_API_HOST + process.env.VUE_APP_ACCOUNTS_PREFIX;
import { sendPostRequest } from '@/helper/requests'

function get_domain(){
  /**
   * Получает домен для установки кукисов
   */
    if(process.env.VUE_APP_COOKIE_DOMAIN !== undefined){
        return process.env.VUE_APP_COOKIE_DOMAIN;
    }else{
        return null;
    }
}

export function clear_stores() {
  /**
   * Очищает все хранилища браузера, связанные с аутентификацией
   */
    localStorage.removeItem('user-token'); // clear your user's token from localstorage
    localStorage.removeItem('isWorker');
    localStorage.removeItem('isStudent');
    localStorage.removeItem('username');
    let domain = get_domain();
    window.$cookies.remove("userMuctr",null,domain);
}

function set_local_store(token, username, uid) {
  /**
   * Сохраняет данные аутентификации в localStorage
   * @param {string} token - JWT токен аутентификации
   * @param {string} username - Имя пользователя
   * @param {string} uid - Уникальный идентификатор пользователя
   */
    localStorage.setItem('user-token', token);
    localStorage.setItem('username', username);
    localStorage.setItem('user-uid', uid);
}

function set_cookie_store(token, username, uid){
  /**
   * Сохраняет данные аутентификации в cookies
   * @param {string} token - JWT токен аутентификации
   * @param {string} username - Имя пользователя
   * @param {string} uid - Уникальный идентификатор пользователя
   */
  window.$cookies.remove("userMuctr",null, get_domain()); // удалим старый
  window.$cookies.set(
    'userMuctr',
    {
      userToken: token,
      userName: username,
      userUid: uid,
    },
    "3y",
    null,
    get_domain(),
    null
  );
}

function set_stores(token, username, uid) {
  /**
   * Сохраняет данные аутентификации во всех хранилищах браузера
   * @param {string} token - JWT токен аутентификации
   * @param {string} username - Имя пользователя
   * @param {string} uid - Уникальный идентификатор пользователя
   */
    set_cookie_store(token, username, uid)
    set_local_store(token, username, uid);
}

const state = {
    uid: null,
    token: null,
    status: null,
    error: null,
    username: null,
    last_check: null,
    isStudent: false,
    isWorker: null,
    need_change_password: false,
    loading: false,
};

const getters = {
  getUsername: state => state.username, /** Возвращает имя пользователя */
  getToken: state => state.token,/** Возвращает токен аутентификации */
  hasCookie: state => () => {
    /**
     * Проверяет наличие cookie с данными пользователя
     */
    return window.$cookies.isKey('userMuctr')
  },
  isLoadingAlive: state => state.loading, /** Проверяет, идет ли процесс загрузки данных аутентификации */
  isCookieLoaded: state => !!state.token, /** Проверяет, загружены ли данные из cookie */
  isAuthenticated: state => state.token !== null, /** Проверяет, аутентифицирован ли пользователь */
  isNeedChangePassword: state => state.need_change_password, /** Проверяет, требуется ли смена пароля */
  isCheckExpired: state => () => {
    /**
     * Проверяет, истекло ли время последней проверки токена
     */
    return (new Date() - state.last_check) > (60 * 1000)
  },
};

const actions = {

  LOAD_FROM_COOKIE: ({commit}) => {
    /**
     * Загружает данные аутентификации из cookie
     * @param {Function} commit - Функция для вызова мутаций
     */
    let userMUCTR = window.$cookies.get("userMuctr");
    if (userMUCTR !== undefined && userMUCTR !== null) {
      commit('SET_TOKEN', userMUCTR.userToken);
      commit('SET_USERNAME', userMUCTR.userName);
      commit('SET_UID', userMUCTR.userUid);
    }
  },
  AUTH_LOGOUT: ({ commit }, {finalizer = () => {}, catcher = () => {}}) => {
    /**
     * Выполняет выход из системы
     * @param {Function} commit - Функция для вызова мутаций
     * @param {Function} finalizer - Функция-обработчик успешного выхода
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = authenticate.AUTHENTICATE.AUTHENTICATION.LOGOUT()
    sendPostRequest(
      url,
      {},
      () => {
        commit('AUTH_LOGOUT')
        clear_stores()
        finalizer()
      },
      (err) => {
        clear_stores()
        commit('AUTH_ERROR', err.error);
        commit('SET_NOT_LOADING');
        catcher()
      }
    )
  },

  CHECK_TOKEN_ALIVE: ({commit, dispatch, getters}) => {
    /**
     * Проверяет актуальность токена аутентификации
     * @param {Function} commit - Функция для вызова мутаций
     * @param {Function} dispatch - Функция для вызова других actions
     * @param {Function} getters - Геттеры Vuex
     */
    commit('SET_LOADING')
    return new Promise((resolve, reject) => {
      if(getters.hasCookie){
        if(!getters.isCookieLoaded){
          dispatch('LOAD_FROM_COOKIE');
        }
        fetch(
          `${HOST_ACCOUNT}authenticate/token/alive/`,
          {
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({token: getters.getToken}),
            method: 'POST'
          }
          ).then(resp => {
            if(!resp.ok) {
              clear_stores();
              commit('SET_NOT_LOADING');
              reject(Error(resp.statusText))
            }else {
              return resp.json()
            }
          }).then(json => {
            if (json.alive === false) {
              clear_stores()
              commit('AUTH_LOGOUT').then(() => {
                reject(json);
              });
            } else {
              commit('SET_NEED_CHANGE_PASSWORD', json.need_change_password);
              commit('SET_CHECK_TIME');
              commit('SET_NOT_LOADING');
              resolve();
            }
          }).catch(error => {
            clear_stores();
            commit('SET_NOT_LOADING');
            reject(error);
          });
      }else{
        commit('SET_NOT_LOADING');
        reject();
      }
    })
  },
};

const mutations = {
    AUTH_LOGOUT: (state) => {
      /**
       * Сбрасывает состояние аутентификации при выходе из системы
       */
        state.status = 'logout';
        state.error = null;
        state.isWorker = null;
        state.isStudent = false;
        state.token = null;
        state.uid = null;
        state.username = null;
        state.last_check = null;
        state.need_change_password = false;
    },
    AUTH_SUCCESS: (state, {token, username, uid}) => {
      /**
       * Устанавливает состояние успешной аутентификации
       * @param {string} token - JWT токен
       * @param {string} username - Имя пользователя
       * @param {string} uid - Уникальный идентификатор пользователя
       */
      state.status = 'success';
      state.token = token;
      state.username = username;
      state.uid = uid;
    },
    SET_CHECK_TIME: (state) => {
      /**
       * Устанавливает время последней проверки токена
       */
        state.last_check = new Date();
    },
    CLEAR_CHECK_TIME: (state) => {
      /**
       * Сбрасывает время последней проверки токена
       */
        state.last_check = null;
    },
    SET_NEED_CHANGE_PASSWORD: (state, need_change) => {
      /**
       * Устанавливает флаг необходимости смены пароля
       * @param {boolean} need_change - Флаг необходимости смены
       */
        state.need_change_password = need_change;
    },
    CLEAR_ERROR: (state) => {
      /**
       * Очищает ошибки аутентификации
       */
        state.status = ''
        state.error = ''
    },
    SET_TOKEN: (state, token) => {
      /**
       * Устанавливает токен аутентификации
       * @param {string} token - JWT токен
       */
        state.token = token
        localStorage.setItem('user-token', token)
    },
    SET_USERNAME: (state, username) => {
      /**
       * Устанавливает имя пользователя
       * @param {string} username - Имя пользователя
       */
        state.username = username
        localStorage.setItem('username', username)
    },
    SET_UID: (state, uid) => {
      /**
       * Устанавливает уникальный идентификатор пользователя
       * @param {string} uid - Уникальный идентификатор
       */
        state.uid = uid
        localStorage.setItem('user-uid', uid)
    },
    SET_LOADING: (state) => {
      /**
       * Устанавливает флаг загрузки
       */
        state.loading = true
    },
    SET_NOT_LOADING: (state) => {
      /**
       * Сбрасывает флаг загрузки
       */
        state.loading = false
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
